import { getAxiosInstance } from '../../react/utils/networkUtil';
import { AppSuccess } from '../models/AppSuccess';
import { MapData_Base } from '../models/MapData';

// Get list map data
export const remote_getListMapData = async (projectId: number): Promise<MapData_Base[]> => {
  return (await getAxiosInstance().get(`api/share-map-data-project-ext/get-shared-map-data/${projectId}`)).data;
};

// End get list map data

// Add map data to project
export type ShareMapDataProject_AddMapData_Request = {
  projectId: number;
  mapDataId: number;
};
export const remote_addMapDataToProject = async (
  request: ShareMapDataProject_AddMapData_Request,
): Promise<AppSuccess<undefined>> => {
  return (await getAxiosInstance().post(`api/share-map-data-project-ext`, request)).data;
};
// End add map data to project

// DELETE /share-map-data-project-ext/:projectId/:mapDataId

export const remote_removeMapDataFromProject = async (
  projectId: number,
  mapDataId: number,
): Promise<AppSuccess<undefined>> => {
  return (await getAxiosInstance().delete(`api/share-map-data-project-ext/${projectId}/${mapDataId}`)).data;
};

export const ShareMapDataProjectAPIs = {
  remote_getListMapData,
  remote_addMapDataToProject,
  remote_removeMapDataFromProject,
};
